import { Injectable } from '@angular/core';
import { SarlaftService } from './sarlaft.service';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from 'src/app/services/general/loader.service';
import { selectQuoteId } from '../storage/property.selectors';
import { Subscription, Observable } from 'rxjs';
import { COTIZACION_PAUSA, OTRO_PRODUCTO, POLIZA_ACTIVA, SARLAFT_END } from 'src/app/routes.constants';
import { CryptoService } from '@app/services/general/Crypto.service';

@Injectable({
    providedIn: 'root'
})
export class CardDataService {


    sessionId: string = '';
    private subscriptions: Subscription = new Subscription();

    constructor(private decrip: CryptoService,
        private sarlaftService: SarlaftService,
        private store: Store,
        private router: Router,
        private route: ActivatedRoute,
        private loaderService: LoaderService
    ) { }

    fetchInitialData(quoteId: string, getResumeDataPago?: boolean, sessionIdparam?: string): Observable<any> {
        this.loaderService.show();

        let body: any;
        if (getResumeDataPago) {
            body = { quoteId: quoteId, getResumeDataPago: true };
        } else {
            body = { quoteId: quoteId, getInitialDataPago: true };
        }


        return new Observable(observer => {
            this.store.select(selectQuoteId).subscribe(storeQuoteId => {
                body.quoteId = storeQuoteId || quoteId;
                quoteId = storeQuoteId || quoteId;
            });
            if (quoteId === '') {
                this.subscriptions.add(this.route.queryParamMap.subscribe(params => {

                    body.quoteId = params.get('quoteId') || 'notengoquoteid';
                    quoteId = params.get('quoteId') || 'notengoquoteid';


                    const cadenita = this.decrip.decryptData(quoteId);
                    console.log('cadenita', cadenita);
                    // Dividir cadenita en quoteId y sessionId
                    const [quoteIdPart, sessionIdPart] = cadenita.split('-');

                    this.sessionId = sessionIdPart;


                    console.log('sessionId', this.sessionId);

                }));
            }
            console.log('body' + JSON.stringify(body));

            this.sarlaftService.initialRequest(body, (error) => {
                console.log('error', error);
            }).subscribe(response => {

                this.handleSarlaftInitialResponseErrors(response, observer);

            });
        });
    }

    private shadow(text: string): string {
        if (text.length <= 2) {
            return text;
        }
        const firstChar = text[0];
        const lastChar = text[text.length - 1];
        const middle = text.slice(1, -1).replace(/./g, '*');
        return firstChar + middle + lastChar;
    }

    // Enmascara documentos manteniendo 2 primeros y 2 ultimos digitos visibles (ej. 12*******41).
    private shadowDocument(text: string): string {
        const clean = String(text || '');
        if (clean.length <= 4) {
            return clean;
        }
        const start = clean.slice(0, 2);
        const end = clean.slice(-2);
        const middle = '*'.repeat(clean.length - 4);
        return start + middle + end;
    }

    // Enmascara las 4 ultimas letras del ultimo apellido con '****' fijo (paridad con mock Sarlaft).
    private shadowLastSurname(text: string): string {
        const clean = String(text || '').trim();
        if (!clean) return '';
        if (clean.length <= 4) return '****';
        return clean.slice(0, clean.length - 4) + '****';
    }

    // Concatena FirstName + SecondName + LastName y aplica el enmascarado al ultimo apellido (SecondLastName || LastName).
    private buildOwnerFullName(response: any): string {
        const first = String(response?.FirstName || '').trim();
        const second = String(response?.SecondName || '').trim();
        const last = String(response?.LastName || '').trim();
        const secondLast = String(response?.SecondLastName || '').trim();

        const maskedTail = this.shadowLastSurname(secondLast || last);
        const head = secondLast
            ? [first, second, last].filter(Boolean).join(' ')
            : [first, second].filter(Boolean).join(' ');

        return [head, maskedTail].filter(Boolean).join(' ').trim();
    }


    private handleSarlaftInitialResponseErrors(response: any, observer: any) {

        // El envelope Mulesoft entrega el mensaje en response.data.message.
        const businessMessage = response?.data?.message ?? response?.message;

        if (businessMessage === 'El inquilino ya tiene pólizas activas') {
            this.router.navigate([COTIZACION_PAUSA], { relativeTo: this.route.parent });
            this.loaderService.hide();
            observer.error(false);
            return;
        }

        if (businessMessage === 'El propietario ya tiene pólizas activas') {
            this.router.navigate([OTRO_PRODUCTO], { relativeTo: this.route.parent });
            this.loaderService.hide();
            observer.error(false);
            return;
        }

        if (businessMessage === 'Ya existe una póliza activa asociada a la matricula inmobiliaria') {
            this.router.navigate([POLIZA_ACTIVA], { relativeTo: this.route.parent });
            this.loaderService.hide();
            observer.error(false);
            return;
        }

        if (response.error) {
            this.router.navigate([SARLAFT_END], { relativeTo: this.route.parent });
            this.loaderService.hide();
            observer.error(true);
            return;
        }

        const cardData = {
            coverages: response.coverages ? response.coverages.map((coverage: any) => coverage.vlocity_ins__ProductName__c) : [],
            name: this.buildOwnerFullName(response),
            planName: response.planName ? response.planName : '',
            PropertyAddress: response.PropertyAddress ?? null,
            DocumentNumber: response.DocumentNumber ? this.shadowDocument(response.DocumentNumber) : '',
            PropertyCity: response.PropertyCity ? response.PropertyCity : '',
            ContractStartDate: response.ContractStartDate ? response.ContractStartDate : '',
            totalAmount: response.vlocity_ins__TotalAmount__c ? response.vlocity_ins__TotalAmount__c : 0,
            idCotizacion: response.idCotizacion ? response.idCotizacion : '',
            // Id Salesforce de la cotizacion (0Q0U...): es el recordId que exigen
            // membresiaservice y startsarlaftevaluation. Ya viene en la carga inicial.
            salesforceQuoteId: response.quoteId ? response.quoteId : '',
            // Id del lead (00QU...); en Motos es el recordId que consume el puller de sarlaft.
            leadId: response.leadId ?? response.Id ?? '',
            estado: response.SURAEstadoProcesoDePago__c ? response.SURAEstadoProcesoDePago__c : '',
        };

        this.loaderService.hide();
        observer.next(cardData);
        observer.complete();

    }
}
